import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import CreateIcon from '@mui/icons-material/Create';
import ChatIcon from '@mui/icons-material/Chat';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { NavLink as RouterLink } from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
	Box, Card,
	CardContent, Divider, Grid,
	Typography, CardHeader,
	IconButton, Menu, MenuItem
} from '@mui/material';

import stringRedutor from 'modules/utils/stringRedutor';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	statsItem: {
		alignItems: 'center',
		display: 'flex'
	},
	statsIcon: {
		marginRight: theme.spacing(1)
	}
}));

function GroupCard({ className, group, updateStatusGroup, ...rest }) {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	function handleClick(currentTarget) {
		setAnchorEl(currentTarget);
	}

	function handleClose() {
		setAnchorEl(null);
	}

	return (
		<Card className={clsx(classes.root, className)} {...rest}>
			<CardHeader
				title={stringRedutor(group.groupTitle, 25)}
				action={
					<Box>
						<IconButton
							aria-label="edit"
							component={RouterLink}
							to={`/grupos/editar/${group.idGroup}`}
						>
							<CreateIcon />
						</IconButton>
						<IconButton
							aria-label="chat"
							component={RouterLink}
							to={`/grupos/chat/${group.idGroup}`}
						>
							<ChatIcon />
						</IconButton>
						<IconButton aria-label="settings" onClick={(e) => handleClick(e.currentTarget)} >
							<MoreVertIcon />
						</IconButton>

						<Menu
							id="basic-menu"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
						>
							<MenuItem onClick={(e) => {
								updateStatusGroup(group.idGroup)
								handleClick(e.currentTarget)
							}}>
								{group.groupIsActive ? "Desativar grupo" : "Ativar grupo"}
							</MenuItem>
						</Menu>
					</Box>
				}
			/>
			<Box flexGrow={1} />
			<Divider />
			<CardContent>
				<Typography
					align="center"
					color="textPrimary"
					variant="body1"
				>
					{stringRedutor(group?.groupDescription, 50)}
				</Typography>
			</CardContent>
			<Box flexGrow={1} />
			<Divider />
			<Box p={2}>
				<Grid
					container
					justifyContent="space-between"
					spacing={2}
				>
					<Grid
						className={classes.statsItem}
						item
					>
						<AccessTimeIcon
							className={classes.statsIcon}
							color="action"
						/>
						<Typography
							color="textSecondary"
							display="inline"
							variant="body2"
						>
							{group?.groupCreateAt ? moment(group?.groupCreateAt).format('DD/MM/YYYY') : "--/--/----"}
						</Typography>
					</Grid>
					<Grid
						className={classes.statsItem}
						item
					>
						<FiberManualRecordIcon
							className={classes.statsIcon}
							sx={{ color: group.groupIsActive ? 'green' : 'red' }}
						/>
						<Typography
							color="textSecondary"
							display="inline"
							variant="body2"
						>
							{group.groupIsActive ? 'Ativo' : 'Inativo'}
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Card>
	);
};

GroupCard.propTypes = {
	className: PropTypes.string,
	group: PropTypes.object.isRequired,
	updateStatusGroup: PropTypes.func.isRequired
};

export default GroupCard;